import { Component, OnInit } from '@angular/core';
import { PdmService } from '../pdm.service';

@Component({
  selector: 'c-pdm-form',
  templateUrl: './pdm-form.component.html',
  styleUrls: ['./pdm-form.component.scss']
})
export class PdmFormComponent implements OnInit {

  constructor(
    public pdmService: PdmService
  ) { }

  ngOnInit() {
  }

}
